import SiteHeaderView from './SiteHeaderView';
import { LANDING_PACKS_URL } from '../../constants/urls';

// Signed-out instance of the shared navbar (see SiteHeaderView), used on the
// auth pages. These render outside the app Router, so everything is a plain
// anchor: Cart points at the marketing pack browser, the account action is an
// inert "Login" label (you're already on the login screen), and the Free
// Download button shows.
export function PublicSiteHeader() {
    return <SiteHeaderView cart={{ href: LANDING_PACKS_URL }} accountLabel="Login" showFreeDownload />;
}

export default PublicSiteHeader;
